import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quiz-availability-stage-working-hours__circle-days-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "quiz-availability-stage-working-hours__week-wrapper" }
const _hoisted_4 = { class: "quiz-availability-stage-working-hours__days-input-wrapper" }
const _hoisted_5 = { class: "h6 no-margin" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSpacer = _resolveComponent("AppSpacer")!
  const _component_AppTimePicker = _resolveComponent("AppTimePicker")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "Working days",
    description: "Select the days and times you are working",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[1] || (_cache[1] = ($event: any) => (_ctx.QuizService.close())),
    prev: !_ctx.QuizService.editing.value,
    class: "quiz-availability-stage-working-hours"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        onClick: _ctx.navigateNext,
        loading: _ctx.QuizService.isSaving()
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.workingHoursData), (day) => {
          return (_openBlock(), _createElementBlock("div", {
            key: day,
            class: _normalizeClass(["quiz-availability-stage-working-hours__circle-days", { 'quiz-availability-stage-working-hours__circle-days--disabled': !_ctx.workingHoursData[day].works }]),
            onClick: ($event: any) => (_ctx.updateWorkingDay(day))
          }, _toDisplayString(_ctx.trim(_ctx.capitalize(day), 2, true)), 11, _hoisted_2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.selectedWorkingDays), (day, index) => {
          return (_openBlock(), _createElementBlock("div", { key: day }, [
            (index !== 0)
              ? (_openBlock(), _createBlock(_component_AppSpacer, {
                  key: 0,
                  type: "simple"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.capitalize(day).slice(0, 3)), 1),
              _createVNode(_component_AppTimePicker, {
                minute: _ctx.workingHoursData[day].startMinute,
                "onUpdate:minute": ($event: any) => ((_ctx.workingHoursData[day].startMinute) = $event),
                hour: _ctx.workingHoursData[day].startHour,
                "onUpdate:hour": ($event: any) => ((_ctx.workingHoursData[day].startHour) = $event),
                displayDirection: index > 1 ? 'top' : 'bottom',
                "start-time": { hour: _ctx.workingHoursData[day].endHour, minute: _ctx.workingHoursData[day].endMinute },
                onClick: ($event: any) => (_ctx.handleClick(_ctx.workingHoursData[day])),
                "onUpdate:time": _ctx.updateTime
              }, null, 8, ["minute", "onUpdate:minute", "hour", "onUpdate:hour", "displayDirection", "start-time", "onClick", "onUpdate:time"]),
              _hoisted_6,
              _createVNode(_component_AppTimePicker, {
                minute: _ctx.workingHoursData[day].endMinute,
                "onUpdate:minute": ($event: any) => ((_ctx.workingHoursData[day].endMinute) = $event),
                hour: _ctx.workingHoursData[day].endHour,
                "onUpdate:hour": ($event: any) => ((_ctx.workingHoursData[day].endHour) = $event),
                displayDirection: index > 1 ? 'top' : 'bottom',
                "end-time": { hour: _ctx.workingHoursData[day].startHour, minute: _ctx.workingHoursData[day].startMinute },
                onClick: ($event: any) => (_ctx.handleClick(_ctx.workingHoursData[day])),
                "onUpdate:time": _ctx.updateTime
              }, null, 8, ["minute", "onUpdate:minute", "hour", "onUpdate:hour", "displayDirection", "end-time", "onClick", "onUpdate:time"]),
              _createVNode(_component_AppDropdown, {
                class: "quiz-availability-stage-working-hours__dropdown",
                type: "simple"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppSelect, {
                    modelValue: _ctx.workingHoursData[day].location,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.workingHoursData[day].location) = $event),
                    options: Object.values(_ctx.WorkLocation),
                    min: 1,
                    "close-on-select": "",
                    openDirection: index > 1 ? 'top' : 'bottom'
                  }, {
                    toggle: _withCtx(({ isFocusing, toggle }) => [
                      _createElementVNode("div", {
                        onClick: toggle,
                        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"])),
                        class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                      }, [
                        _createVNode(_component_AppIcon, { name: "arrow" })
                      ], 42, _hoisted_7)
                    ]),
                    label: _withCtx(({ selected }) => [
                      _createTextVNode(_toDisplayString(selected), 1)
                    ]),
                    "dropdown-item": _withCtx(({ option }) => [
                      _createElementVNode("p", null, _toDisplayString(option), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "openDirection"])
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back", "prev"]))
}